import { Tooltip, Typography } from '@mui/material';
import React from 'react';
import { truncateString } from "../../commonFunctions/CommonFunctions";

// Define an interface for your component props
interface StatusProps {
    value: string;
    toolTip?: boolean;
    style?: React.CSSProperties;
}

// Normalize and convert to string for display
const getDisplayValue = (value: string | boolean): string => {
    if (value === true || value === 'true') return 'Active';
    if (value === false || value === 'false') return 'Inactive';
    return String(value);
};

const getStatusColor = (value: string | boolean): string => {
    const val = String(value).toLowerCase();

    switch (val) {
        case 'true':
        case 'active':
        case 'sanctioned':
        case    'completed':
            return 'green';
        case 'false':
        case 'inactive':
        case 'in active':
            return '#A9A9A9'; // gray
        case 'pending':
            return 'orange';
        case 'rejected':
            return '#D2122E'; // red
        case 'absent':
            return '#AA0000'; // deep red
        default:
            return 'black';
    }
};

export const WSStatus: React.FC<StatusProps> = React.memo(({ value, toolTip = false, style }) => {
    const statusColor = getStatusColor(value);
    const displayValue = getDisplayValue(value).toUpperCase();

    return (
        <div style={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}>
            <span
                style={{
                    backgroundColor: statusColor,
                    borderRadius: '50%',
                    width: 8,
                    height: 8,
                    marginRight: 6,
                    display: 'inline-block',
                }}
            />
            {toolTip ? (
                <Tooltip title={displayValue} placement="top">
                    <Typography style={{ color: statusColor, fontSize: '0.875rem', ...style }}>
                        {truncateString(displayValue, 20)}
                    </Typography>
                </Tooltip>
            ) : (
                <Typography style={{ color: statusColor, fontSize: '0.875rem', ...style }}>
                    {displayValue}
                </Typography>
            )}
        </div>
    );
});


